
export const COMPANY_USERS_REMINDER = {
  ADD_REMINDER_REQUEST: 'ADD_REMINDER_REQUEST',
  ADD_REMINDER_SUCCESS: 'ADD_REMINDER_SUCCESS',
  ADD_REMINDER_FAIL: 'ADD_REMINDER_FAIL',
  UPDATE_REMINDER_REQUEST: 'UPDATE_REMINDER_REQUEST',
  UPDATE_REMINDER_SUCCESS: 'UPDATE_REMINDER_SUCCESS',
  UPDATE_REMINDER_FAIL: 'UPDATE_REMINDER_FAIL'
};
